const Callout = ({
   estado,
   titulo,
   children
}) => {
   var bg = estado
   var icon = ""
   switch (estado) {
      case "success":         
         icon = 'fas fa-check-circle'
         break
      case "secondary":         
         icon = 'far fa-times-circle'
         break
      case "danger":         
         icon = 'fas fa-ban'
         break
      case "info":         
         icon = 'fas fa-info-circle'
         break
      case "warning":         
         icon = 'fas fa-exclamation-triangle'
         break
      default:         
         icon = 'far fa-question-circle'
         break
   }
   return (
      <div className={`callout callout-${bg} my-2 shadow`}>
         <h2 className={`float-right text-${bg}`}>
            <i className={`far ${icon}`}></i>
         </h2>
         <h6 className={`text-${bg}`}>
            {titulo}
         </h6>
         <div>{children}</div>
      </div>
   )
}
export default Callout